import React from 'react'
import s from './AttentionCell.module.scss'
import { ReactComponent as FeedbackIcon } from 'assets/icons/message.svg'
import { ReactComponent as DockIcon } from 'assets/icons/dock.svg'

const STATUS_META = {
	revision_requested: { label: 'Revision needed', tone: 'urgent' },
	submitted_for_review: { label: 'Pending review', tone: 'review' },
	draft: { label: 'Draft', tone: 'draft' },
	draft_only: { label: 'Draft', tone: 'draft' },
	approved: { label: 'Approved', tone: 'approved' },
	final: { label: 'Approved', tone: 'approved' },
}

const normalize = value =>
	String(value || '')
		.trim()
		.toLowerCase()
		.replace(/\s+/g, '_')
		.replace(/-/g, '_')

const AttentionCell = ({
	essayStatus,
	feedbackCount = 0,
	docsCount = 0,
	isNewApplication = false,
	essayLoading = false,
	hasPendingStudentLorRequest = false,
}) => {
	const key = normalize(essayStatus)
	const meta = key ? STATUS_META[key] : null
	const showEssayPill = meta && !hasPendingStudentLorRequest

	return (
		<div className={s.wrap}>
			{hasPendingStudentLorRequest ? (
				<span className={`${s.pill} ${s.lorRequest}`}>
					<span className={s.pillIcon}>
						<FeedbackIcon />
					</span>
					Request LoR
				</span>
			) : null}

			{essayLoading && !showEssayPill && !hasPendingStudentLorRequest ? (
				<span className={`${s.pill} ${s.loading}`}>—</span>
			) : showEssayPill ? (
				<span className={`${s.pill} ${s[meta.tone]}`}>{meta.label}</span>
			) : null}

			{isNewApplication && <span className={`${s.pill} ${s.newApp}`}>New</span>}

			{feedbackCount > 0 && (
				<span className={s.counter}>
					<span className={s.icon}>
						<FeedbackIcon />
					</span>
					<span className={s.value}>+{feedbackCount}</span>
				</span>
			)}

			{docsCount > 0 && (
				<span className={s.counter}>
					<span className={s.icon}>
						<DockIcon />
					</span>
					<span className={s.value}>+{docsCount}</span>
				</span>
			)}
		</div>
	)
}

export default AttentionCell
